//
// Useful functions and classes
// --------------------------------------------------

// Cookies
export const setCookie = (cname, cvalue, exdays) => {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
};

export const setHourlyCookie = (cname, cvalue, exhours) => {
	const d = new Date();
	d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
	const expires = `expires=${d.toUTCString()}`;
	document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

export const getCookie = (cname) => {
	const name = `${cname}=`;
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

export const loadScript = (name, src) => {
	return new Promise((resolve, reject) => {
		if (document.querySelector(`#${name}-js`)) {
			console.log(`Already loaded: ${src}`);
			resolve(document.querySelector(`#${name}-js`).getAttribute("src"));
		} else {
			const script = document.createElement("script");
			script.src = src;
			script.id = `${name}-js`;
			script.async = true;
			script.src = src;

			script.onload = () => {
				console.log(`Loaded: ${src}`);
				resolve(src);
			};
			script.onerror = () => {
				reject(`Error: ${src} not loaded`);
			};
			document.body.appendChild(script);
		}
	});
};

// Csrf
export const formAddCsrfProtection = async (form) => {
	if (!!form.querySelector("input[name='csrfmiddlewaretoken']") === false) {
		await fetch("/csrf/", {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				const input = document.createElement("input");
				input.setAttribute("name", "csrfmiddlewaretoken");
				input.setAttribute("type", "hidden");
				input.value = data;
				form.appendChild(input);
			})
			.catch((error) => {
				console.warn(" --- Error: ", error);
			});
	}
};

// fixes INP issues by yielding on medium and background tasks
export const yieldToMainBackground = () => {
	return new Promise((resolve) => {
		if ("scheduler" in window) {
			if ("yield" in window.scheduler) {
				return window.scheduler.yield().then(() => resolve(true));
			}

			if ("postTask" in window.scheduler) {
				return window.scheduler.postTask(() => resolve(true), {
					priority: "user-visible",
				});
			}
		}
		setTimeout(() => {
			resolve(true);
		}, 0);
	});
};

// send Analytics event on link click
export const linkGAEvent = (event_label) => {
	if (typeof gtag !== "undefined") {
		gtag("event", "click", {
			event_category: "link",
			event_label: event_label,
		});
	} else {
		console.log(event_label);
	}
};
// Publytics
export const sendPublyticsEvent = (event_name, values = null) => {
	const checkCmp = new CmpCheck();
	checkCmp.checkConsent().then((response) => {
		if (response === false) return;
		// biome-ignore format lint: reason=external script
		window.publytics = window.publytics || function() { (window.publytics.q = window.publytics.q || []).push(arguments) };
		if (values) {
			publytics(event_name, { props: values });
		} else {
			publytics(event_name);
		}
	});
};

export const trackLinkEvent = (event_label) => {
	linkGAEvent(event_label);
	sendPublyticsEvent(event_label);
};

export class CmpCheck {
	constructor() {
		this.show_ads = null;
	}
	async checkConsent() {
		if (this.show_ads === null) {
			return new Promise((resolve, reject) => {
				if ("debug" in document.body.dataset) {
					this.show_ads = true;
					resolve(this.show_ads);
				}
				window.__tcfapi?.("addEventListener", 2, (tcData, success) => {
					if (success && tcData) {
						if (!tcData.gdprApplies) {
							this.show_ads = true;
							resolve(this.show_ads);
						}
						if (
							tcData.eventStatus === "tcloaded" ||
							tcData.eventStatus === "useractioncomplete"
						) {
							__tcfapi(
								"removeEventListener",
								2,
								(_success) => {},
								tcData.listenerId,
							);
							// console.log({ tcData });
							if (
								Object.keys(tcData.purpose.consents).length === 0 &&
								tcData.purpose.consents.constructor === Object
							) {
								this.show_ads = false;
								resolve(this.show_ads);
							} else {
								this.show_ads = true;
								resolve(this.show_ads);
							}
						}
					}
				});
			});
		}
		return this.show_ads;
	}
}

export const isMobile = () => {
	const device = document.body.dataset.device;
	if (device === "mobile") {
		return true;
	}
	return false;
};

export const loadEndless = async () => {
	const module = await import(
		"endless_pagination/endless-pagination-module.js"
	);
	return module.endlessPaginate;
};

export const isDebug = () => {
	return document.body.dataset.debug === "true";
};
